
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`A l'origine, ce vaccin devait être conservé à moins 70 degrés environ,
`}<a parentName="p" {...{
        "href": "515639387875"
      }}>{`ce qui nécessitait des congélateurs spéciaux et toute une logistique`}</a>{`.
Le 7 mai,
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/covid-19-impfstoff-pfizer-biontech-ein-monat-kuehlschrank-lagern.html"
      }}>{`Swissmedic`}</a>{`
a toutefois approuvé son stockage durant un mois maximum à des températures
entre 2 et 8 degrés. Cette décision a été prise après que Pfizer lui a soumis de
nouvelles données. Le maniement du produit est ainsi plus aisé.`}</p>
    <p>{`Ce vaccin n’est pas bon marché. Ces montants sont maintenus secrets mais selon
les `}<a parentName="p" {...{
        "href": "762891513855"
      }}>{`chiffres`}</a>{` parus dans la presse suite à une erreur d'une
ministre belge, l’Europe payerait 12 euros à l'unité (tarif en décembre 2020).`}</p>
    <p>{`L’emploi d’une nouvelle technologie, passant par la génétique, crée une certaine
`}<a parentName="p" {...{
        "href": "404485565357"
      }}>{`appréhension`}</a>{` dans la population. Alessandro Diana se montre
toutefois rassurant: l’ARN messager n’entre pas dans le noyau de nos cellules
(où notre matériel génétique est stocké), le code qui leur est envoyé disparaît
en 48 heures de notre corps et ce vaccin est donc sûr.`}</p>
    <p>{`La fréquence d'effets secondaires désagréables mais peu dangereux (du type état
grippal), en particulier après l'injection de la deuxième dose, a surpris
certains experts. Ce point faible, toutefois, est paradoxalement un bon signe:
il signifie que le système immunitaire réagit.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;